import { createFileRoute } from '@tanstack/react-router';

import { ArticleBrowse } from '@/module/Author/Article';

export const Route = createFileRoute('/_auth/author/_author/article/_article/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ArticleBrowse />;
}
